import { getLocalStorage } from "./localStorage";
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";
import { FaThreads } from "react-icons/fa6";
export const getAuthDetails = () => {
  const token = localStorage.getItem("authToken");
  const mobileNumber = getLocalStorage("mobileNumber");

  return {
    isAuthenticated: !!token,
    mobileNumber: mobileNumber || null,
  };
};

export const phoneNo = "9876543210";
export const app_Name = "iDiag Pvt Ltd";
export const whatsappLink = "https://wa.me/919876543210";
export const playStoreUrl =
  "https://play.google.com/store/apps/details?id=com.idiag.app&pcampaignid=web_share";
export const appStoreUrl = "";

export const socialLinks = [
  {
    name: "Facebook",
    icon: FaFacebook,
    url: "https://www.facebook.com/idiag?mibextid=ZbWKwL",
  },
  {
    name: "Instagram",
    icon: FaInstagram,
    url: "https://www.instagram.com/idiag/",
  },
  {
    name: "LinkedIn",
    icon: FaLinkedin,
    url: "https://www.linkedin.com/company/idiag/",
  },
  {
    name: "Threads",
    icon: FaThreads,
    url: "https://www.threads.com/@idiag",
  },
  {
    name: "Youtube",
    icon: FaYoutube,
    url: "https://www.youtube.com/@iDiag/featured",
  },
];
export const formatToISO = (date) => {
  if (!date) return null;
  const d = new Date(date);
  if (isNaN(d.getTime())) return null;
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  const seconds = String(d.getSeconds()).padStart(2, "0");
  const isoString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;

  return isoString;
};

export const extractDateTimeFromComments = (comments) => {
  console.log(comments);

  if (!comments || typeof comments !== "string")
    return {
      scheduledDate: null,
      scheduledTime: null,
      rescheduledFromDate: null,
      rescheduledFromTime: null,
      rescheduledToDate: null,
      rescheduledToTime: null,
    };

  const parsedDetails = {
    scheduledDate: null,
    scheduledTime: null,
    rescheduledFromDate: null,
    rescheduledFromTime: null,
    rescheduledToDate: null,
    rescheduledToTime: null,
  };

  // Regex for rescheduled appointment
  const rescheduledRegex =
    /rescheduled from (\d{4}-\d{2}-\d{2}) (\d{1,2}:\d{2}:\d{2}\s*(?:AM|PM)?) to (\d{4}-\d{2}-\d{2}) (\d{1,2}:\d{2}:\d{2}\s*(?:AM|PM)?)/i;

  // Regex for appointment booking
  const appointmentRegex =
    /(?:Home Collection|Appointment Booking) from idiag(?:\s*on\s*(\d{4}-\d{2}-\d{2})\s*at\s*(\d{1,2}:\d{2}\s*(?:AM|PM)?)?)?/i;

  // Check for rescheduled appointment first
  const rescheduledMatch = comments.match(rescheduledRegex);
  if (rescheduledMatch) {
    parsedDetails.rescheduledFromDate = rescheduledMatch[1];
    parsedDetails.rescheduledFromTime = formatTimeTo12Hour(rescheduledMatch[2]);
    parsedDetails.rescheduledToDate = rescheduledMatch[3];
    parsedDetails.rescheduledToTime = formatTimeTo12Hour(rescheduledMatch[4]);
    return parsedDetails;
  }

  // Check for appointment booking
  const appointmentMatch = comments.match(appointmentRegex);
  if (appointmentMatch) {
    if (appointmentMatch[1]) parsedDetails.scheduledDate = appointmentMatch[1];
    if (appointmentMatch[2]) {
      parsedDetails.scheduledTime = formatTimeTo12Hour(appointmentMatch[2]);
    }
  }

  return parsedDetails;
};

// Helper function to format time to 12-hour format
function formatTimeTo12Hour(timeString) {
  if (!timeString) return null;

  // Match time with optional AM/PM
  const timeParts = timeString.match(
    /(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)?/i,
  );

  if (!timeParts) return null;

  let hours = parseInt(timeParts[1], 10);
  const minutes = timeParts[2];
  let ampm = timeParts[3] ? timeParts[3].toUpperCase() : "";

  // Convert to 12-hour format
  if (hours > 12) {
    hours -= 12;
    ampm = "PM";
  } else if (hours === 0) {
    hours = 12;
    ampm = "AM";
  } else if (hours === 12) {
    ampm = ampm || "PM";
  } else {
    ampm = ampm || "AM";
  }

  // Pad hours and minutes with leading zero
  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");

  return `${formattedHours}:${formattedMinutes} ${ampm}`;
}

export const formatDateTime = (isoString) => {
  const [date, time] = isoString.split("T");
  const [year, month, day] = date.split("-");
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return `${day} ${months[parseInt(month) - 1]} ${year} at ${formatTimeTo12Hour(
    time,
  )}`;
};

export const formatDateTimeIST = (isoString) => {
  // Convert UTC ISO string to a Date object
  const utcDate = new Date(isoString);

  // Convert to IST (UTC +5:30)
  const istOffset = 5.5 * 60; // IST is UTC +5:30 in minutes
  const istDate = new Date(utcDate.getTime() + istOffset * 60000);

  // Format date and time
  const [date, time] = istDate.toISOString().split("T");
  const [year, month, day] = date.split("-");
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return `${day} ${months[parseInt(month) - 1]} ${year} at ${formatTimeTo12Hour(
    time,
  )}`;
};
